<template>
    <article class="show-picker-item" :key="show.showId">
        <a :href="show.href" @click.prevent="showItemClicked(show.showId)">
            <div class="thumb-wrapper">
                <div class="show-selector" :class="{ selected: isSelected }"></div>
                <div class="lock-icon-wrapper" v-if="shouldRenderLockIcon">
                    <div class="lock-icon-src" />
                </div>
                <img class="thumb" :src="show.thumb" :alt="show.showTitle" loading="lazy" />
                <div
                    class="overlay"
                    :class="{ selected: isSelected, unselected: !isSelected }"></div>
            </div>
        </a>
    </article>
</template>

<script>
    export default {
        name: 'ShowSelectItem',

        props: {
            show: Object,
            isSelected: {
                type: Boolean,
                default: false,
            },
            isColdStartPremiumShowPickerEnabled: {
                type: Boolean,
                default: false,
            },
        },

        computed: {
            shouldRenderLockIcon() {
                return (
                    !this.show.isContentAccessibleInCMS && this.isColdStartPremiumShowPickerEnabled
                );
            },
        },

        methods: {
            showItemClicked() {
                this.$emit('showItemSelected', this.show);
            },
        },
    };
</script>
